import { render, staticRenderFns } from "./EzonePayPayments.html?vue&type=template&id=6c7822d3&external"
import script from "./EzonePayPayments.js?vue&type=script&lang=js&external"
export * from "./EzonePayPayments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports